import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-support-ticket-list',
  templateUrl: './support-ticket-list.component.html',
  styleUrls: ['./support-ticket-list.component.scss'],
})
export class SupportTicketListComponent extends BaseListCtl {
  public isProfileTabActive: boolean = false;
  public isSupportAdmin: boolean = false;
  public selectedSupport: any = {};
  public attributeList: any = [];
  public maxFileSize = 512000;
  public imagePreview: string | ArrayBuffer | null = null;
  public imageCommentPreview: string | ArrayBuffer | null = null;
  public fileObj: any;
  public commentfileObj: any;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
  ) {
    super(locator.config.get('endpoint.supportticket'), locator, route);
    let _self = this;
    _self.checkUserOrgId();
    _self.getUsecaseDetails();
  }

  //-------------------------------Support Section-------------------------------------------------

  /**
   * Reset form
   */
  override resetForm(): void {
    this.mode = '';
    this.imagePreview = null;
    super.resetForm();
  }

  /**
   * populate form
   * @param form
   * @param data
   */
  override async populateForm(form: any, data: any) {
    form.id = data.id;
    form.description = data.description;
    form.imageId = data.imageId;
    form.status = data.status;
    form.category = data.category;
    form.imageId = data.imageId;
    form.usecaseName = data.usecaseName;
    form.orgName = data.orgName;
    form.title = data.title;
    form.usecaseId = data.usecaseId;
    form.createdTime = data.createdTime;
    form.createdDate = data.createdDate;
  }

  /**
   * switch main and archive
   * @param tab
   */
  toggleTab(tab: string): void {
    this.isProfileTabActive = tab === 'profile';
    this.searchArchived();
  }

  /**
   * searchArchived
   * @param callback
   */
  public async searchArchived(callback?: any) {
    var _self = this;

    _self.form.searchError = false;
    _self.form.searchMessage = '';

    this.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        let url = property + '/searchArchived/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;

        this.locator.http.post(
          url,
          _self.form.searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }

              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            if (res.success) {
              _self.form.archivedlist = res.result.data;
              _self.form.pageCount = res.result.pageCount;
              _self.form.pageSize = res.result.pageSize;
              _self.form.pageNos = _self.form.pageNo;
              _self.form.pageNoList = [];
              //Build page number list
              for (let i = 0; i < _self.form.pageCount; i++) {
                _self.form.pageNoList.push(i);
              }

              //Check empty list
              if (_self.form.archivedlist.length == 0) {
                _self.form.message = 'No record found';
                _self.form.error = true;
              }

              // Add data in Datatable
              //_self.initializeDataTable();

              if (callback) {
                callback();
              }
            }

            if (callback) {
              callback();
            }
          },
        );
      });
  }

  /**
   * Retrieve a record and execute callback after deletion
   *
   * @param id
   * @param callback
   */
  public async retrieve(id: any, callback?: any) {
    var _self = this;
    _self.form.error = false;
    _self.form.message = '';
    _self.form.isConfirmDelete = true;
    if (id && id > 0) {
      if (_self.form.isConfirmDelete) {
        let flag = confirm('Are you sure ?');
        if (!flag) {
          return;
        }

        let url =
          this.locator.config.get('endpoint.ui.forms') + '/retrieve/' + id;
        this.locator.http.get(url, async function (res: any, error: any) {
          if (error) {
            return;
          }
          _self.form.error = !res.success;
          _self.form.message = res.result.message;
          if (res.success) {
            _self.form.message = 'Data is retrieved';
            _self.searchArchived();
            _self.search();
            if (callback) {
              callback(res, error);
            }
          }
        });
      }
    }
  }

  /**
   * Get usecase details
   */
  public async getUsecaseDetails() {
    let _self = this;
    let attrUrl =
      _self.locator.config.get('endpoint.userstory') +
      '/getDetails/support-ticket';
    _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
      _self.getUsecaseSchema(res.result.data['id']);
    });
  }

  /**
   * Get usecase attributes with data
   * @param usecaseId
   */
  public async getUsecaseSchema(usecaseId: any) {
    let _self = this;
    let attrUrl =
      _self.locator.config.get('endpoint.userstory.attributes') +
      '/list/' +
      usecaseId;
    _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
      _self.attributeList = res.result.data;
    });
  }

  /**
   * transform
   * @param callback
   */
  transform(value: string, limit: number): string {
    if (!value) return '';
    return value.length > limit ? value.substring(0, limit) + '...' : value;
  }

  /**
   * Summit support ticket
   * @param callback
   */
  public async summitSupport() {
    var _self = this;
    _self.form.error = false;
    _self.form.message = '';
    _self.form.inputerror = {};
    let url =
      _self.locator.config.get('endpoint.supportticket') + '/summitSupport';
    _self.locator.http.postMutipart(
      url,
      _self.form.data,
      _self.fileObj,
      function (res: any, error: any) {
        if (error) {
          return;
        }
        _self.form.error = !res.success;
        _self.form.message = res.result.message;

        if (res.success) {
          _self.form.message = 'Data is saved';
          _self.populateForm(_self.form, _self.form.data);
          _self.search();
          _self.resetForm();
        } else {
          _self.form.inputerror = res.result.inputerror;
        }
      },
    );
  }

  /**
   * Save support ticket
   * @param callback
   */
  public async saveSupport(callback?: any) {
    var _self = this;
    _self.form.error = false;
    _self.form.message = '';
    _self.form.inputerror = {};

    let url =
      _self.locator.config.get('endpoint.supportticket') + '/saveSupport';
    this.locator.http.postMutipart(
      url,
      this.form.data,
      this.fileObj,
      function (res: any, error: any) {
        if (error) {
          return;
        }
        _self.form.error = !res.success;
        _self.form.message = res.result.message;
        if (res.success) {
          _self.form.message = 'Data is saved';
          // Set a 2-second delay to call clearMessage
          _self.form.data['id'] = res.result.data;
          _self.populateForm(_self.form, _self.form.data);
          _self.search();
          setTimeout(() => {
            _self.clearMessage(_self.form);
             _self.resetForm();
          }, 5000);
          if (callback) {
            callback();
          }
        } else {
          _self.form.inputerror = res.result.inputerror || {};

          // Combine all inputerror messages into one string
          let messages = [];
          for (let key in _self.form.inputerror) {
            if (_self.form.inputerror[key]) {
              messages.push(_self.form.inputerror[key]);
            }
          }

          // If detailed errors exist, show those. Otherwise show general message.
          _self.form.message =
            messages.length > 0
              ? messages.join(', ')
              : res.result.message || res.message || 'Input error';
        }
      },
    );
  }

  /**
   * upload image file
   * @param event
   */
  public async onFileChanged(event: any) {
    this.showPreview(event);
    const fileObj = event.target.files[0];
    if (fileObj.size > this.maxFileSize) {
      this.form.message = 'File size should not exceed 0.5 MB.';
    } else {
      this.form.message = null;
      this.fileObj = fileObj;
    }
  }

  /**
   * Show preview of the image
   * @param event
   */
  public async showPreview(event: any) {
    const target = event.target as HTMLInputElement;
    const file = target.files ? target.files[0] : null;

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string; // Convert to a base64 string
      };
      reader.readAsDataURL(file); // Start reading the file
    }
  }

  /**
   * Update support ticket status
   * @param status
   */
  changeStatus(status: string) {
    this.form.data.status = status;
    this.save();
  }

  //-------------------Search Section-----------------------

  /**
   * Search Open
   */
  public async searchOpen() {
    var _self = this;
      this.form.list = [];
    if (_self.form.searchParams['status'] == 'Open') {
      _self.form.searchParams['status'] = null;
    } else {
      _self.form.searchParams['status'] = 'Open';
    }
    _self.search();
  }

  /**
   * Search Draft
   */
  public async searchDraft() {
    var _self = this;
          this.form.list = [];
    if (_self.form.searchParams['status'] == 'Draft') {
      _self.form.searchParams['status'] = null;
    } else {
      _self.form.searchParams['status'] = 'Draft';
    }
    _self.search();
  }

  /**
   * Search Draft
   */
  public async searchClose() {
    var _self = this;
          this.form.list = [];
    if (_self.form.searchParams['status'] == 'Close') {
      _self.form.searchParams['status'] = null;
    } else {
      _self.form.searchParams['status'] = 'Close';
    }
    _self.search();
  }

  /**
   * Search Draft
   */
  public async searcInProgress() {
    var _self = this;
          this.form.list = [];
    if (_self.form.searchParams['status'] == 'In Progress') {
      _self.form.searchParams['status'] = null;
    } else {
      _self.form.searchParams['status'] = 'In Progress';
    }
    _self.search();
  }

  /**
   * Search In Progress
   */
  public async searchInProgress() {
    var _self = this;
          this.form.list = [];
    if (_self.form.searchParams['status'] == 'In Progress') {
      _self.form.searchParams['status'] = null;
    } else {
      _self.form.searchParams['status'] = 'In Progress';
    }
    _self.search();
  }

  /**
   * Admin Search
   * @param callback
   */
  public async adminSearch(callback?: any) {
    var _self = this;
    var _self = this;

    _self.form.searchError = false;
    _self.form.searchMessage = '';

    this.locator.config
      .getProperty('endpoint.supportticket')
      .then((property: string) => {
        let url = property + '/adminSearch/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;

        this.locator.http.post(
          url,
          _self.form.searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }

              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            if (res.success) {
              _self.form.list = res.result.data;
              _self.form.pageCount = res.result.pageCount;
              _self.form.pageSize = res.result.pageSize;
              _self.form.pageNos = _self.form.pageNo;
              _self.form.pageNoList = [];
              //Build page number list
              for (let i = 0; i < _self.form.pageCount; i++) {
                _self.form.pageNoList.push(i);
              }

              //Check empty list
              if (_self.form.list.length == 0) {
                _self.form.message = 'No record found';
                _self.form.error = true;
              }

              // Add data in Datatable
              //_self.initializeDataTable();

              if (callback) {
                callback();
              }
            }

            if (callback) {
              callback();
            }
          },
        );
      });
  }

  //-------------------------------Comment Section-------------------------------------------------

  /**
   * Check user orgId and support admin id
   */
  public async checkUserOrgId() {
    var _self = this;
    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    const lstr: string | null = localStorage.getItem(keySuffix + 'userContext');
    const userContext = lstr ? JSON.parse(lstr) : null;
    if (userContext) {
      if (userContext.roleName == 'Support Admin') {
        if (userContext.loginId == 'support.admin@nenosystems.com') {
          _self.isSupportAdmin = true;
          if (_self.isSupportAdmin) {
            _self.adminSearch();
          }
        }
      }
    }
  }

  /**
   * Form contains preload data, error/sucess message
   */
  public commentform: any = {
    error: false,
    message: '',
    preload: null,
    inputerror: {},
    data: { id: 0 },
    //Attributes for list page
    searchError: false,
    searchParams: {},
    searchMessage: '',
    usecasedocs: [],
    usecasedocparams: {},
    list: [],
    pageNo: 0,
    pageNos: 0,
    pageCount: 0,
    pageSize: 50,
    pageNoList: [1],
    isConfirmDelete: true, // use to call delete  ask confirm box
  };

  setCommentStatus() {
    var _self = this;
    _self.commentform.data['ticketStatus'] = _self.form.data.status;
  }

  /**
   * Save Comment
   * @param callback
   */
  public async saveComment(callback?: any) {
    var _self = this;
    _self.changeStatus(_self.form.data.status);
    _self.commentform.error = false;
    _self.commentform.message = '';
    _self.commentform.inputerror = {};
    _self.commentform.data['supportTicketId'] = _self.form.data.id;
    _self.commentform.data['supportTicketTitle'] = _self.form.data.title;
    _self.commentform.data['ticketStatus'] = _self.form.data.status;

    let url =
      _self.locator.config.get('endpoint.supportcomment') + '/saveComment';
    this.locator.http.postMutipart(
      url,
      this.commentform.data,
      this.commentfileObj,
      function (res: any, error: any) {
        if (error) {
          return;
        }
        _self.commentform.error = !res.success;
        _self.commentform.message = res.result.message;
        if (res.success) {
          _self.commentform.message = 'Comment is send successfully';
          _self.resetcommentForm();
          // Set a 2-second delay to call clearMessage
          setTimeout(() => {
            _self.clearMessage(_self.commentform);
          }, 5000);
          if (callback) {
            callback();
          }
        } else {
          _self.form.inputerror = res.result.inputerror;
        }
      },
    );
  }

  resetcommentForm() {
    this.commentform.error = false;
    this.commentform.message = '';
    this.commentform.data = { id: 0 };
    this.commentform.inputerror = {};
    this.imageCommentPreview = null;
    this.commentfileObj = null;
  }

  /**
   * Searhs Comment
   */
  public async searchComment(supportTicket: any, callback?: any) {
    var _self = this;
    _self.selectedSupport = supportTicket;
    _self.commentform.searchError = false;
    _self.commentform.searchMessage = '';
    _self.commentform.list = [];
    _self.commentform.searchParams['supportTicketId'] = Number(
      _self.selectedSupport['id'],
    );

    let url = _self.locator.config.get('endpoint.supportcomment') + '/search';

    this.locator.http.post(
      url,
      _self.commentform.searchParams,
      function (res: any, error: any) {
        if (error) {
          if (callback) {
            callback(error);
          }
          return;
        }
        _self.commentform.searchError = !res.success;
        _self.commentform.searchMessage = res.result['message'];
        if (res.success) {
          _self.commentform.list = res.result.data;
          _self.commentform.pageCount = res.result.pageCount;
          _self.commentform.pageSize = res.result.pageSize;
          _self.commentform.pageNos = _self.commentform.pageNo;
          _self.commentform.pageNoList = [];
          //Build page number list
          for (let i = 0; i < _self.commentform.pageCount; i++) {
            _self.commentform.pageNoList.push(i);
          }
          //Check empty list
          if (_self.commentform.list.length == 0) {
            _self.commentform.message = 'No record found';
            _self.commentform.error = true;
          }
          if (callback) {
            callback();
          }
        }
        if (callback) {
          callback();
        }
      },
    );
  }

  /**
   * Retrieve a record and execute callback after deletion
   *
   * @param id
   * @param callback
   */
  public async onCommentFileChanged(event: any) {
    this.showCommentPreview(event);
    const fileObj = event.target.files[0];
    if (fileObj.size > this.maxFileSize) {
      this.form.message = 'File size should not exceed 0.5 MB.';
    } else {
      this.form.message = null;
      this.commentfileObj = fileObj;
    }
  }

  /**
   * Comment image preview
   * @param event
   */
  public async showCommentPreview(event: any) {
    const target = event.target as HTMLInputElement;
    const file = target.files ? target.files[0] : null;

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imageCommentPreview = reader.result as string; // Convert to a base64 string
      };
      reader.readAsDataURL(file); // Start reading the file
    }
  }

  mode: string | undefined;
  getView(id: number, mode: 'edit' | 'view') {
    this.get(id);
    this.mode = mode;
  }

  get visibleList() {
    return this.isSupportAdmin
      ? this.form.list.filter(
          (item: { status: string }) => item.status !== 'Draft',
        )
      : this.form.list;
  }

  override delete(callback?: any): void {
    super.delete(this.form.data.id);
    this.resetForm();
  }

 // Add this at the top of your class with other properties
  private originalList: any[] = []; // To store the original unfiltered list

  // Modify your searchById function:
  searchById(): void {
  const idInput = this.form.searchParams['id'];

  const id = Number(idInput);

  // If ID is not a valid number, show error
  if (isNaN(id)) {
    this.form.searchError = true;
    this.form.searchMessage = 'Please enter a valid numeric ID';
    return;
  }

  // Store original list if this is the first search
  if (this.originalList.length === 0 && this.form.list.length > 0) {
    this.originalList = [...this.form.list];
  }

  // Filter the current list by ID
  this.form.list = this.originalList.filter((item: any) =>
      item.id.toString().includes(idInput.toString()),
  );

  // Handle no results found
  if (this.form.list.length === 0) {
    this.form.searchError = true;
    this.form.searchMessage = 'No ticket found with this ID';
  } else {
    this.form.searchError = false;
    this.form.searchMessage = `${this.form.list.length} ticket(s) found`;
  }
  }

  override getDocThumbnail(skey: number) {
    if (!skey) {
      skey = 0;
    }
    let docAPI = this.locator.config.get("DOC_API");
    return docAPI + "th/" + skey + "?t=" + this.imageTimestamp;;
  }
}
